<script setup lang="ts" generic="Value">
import { computed } from 'vue';
import { container } from '@shared/common/dependency-injection/domain/container';
import type { SelectFormField } from '@shared/common/form/domain/form/field/select.form-field';
import FormFieldMessages from '@shared/common/form/application/component/FormFieldMessages.vue';
import type { FormFieldSelectComponent } from '@shared/common/form/application/component/select/form-field-select-component.types';
import { FormDependencyTypes } from '@shared/common/form/form.dependency-types';

const model = defineModel<SelectFormField<Value>>({ required: true });
const component = container.get<FormFieldSelectComponent>(FormDependencyTypes.FormFieldSelectComponent);

const selectedValue = computed({
  get: () => model.value.value,
  set: (value: Value | null) => {
    model.value.value = value as SelectFormField<Value>['value'];
  },
});

function onChange(value: Value | '' | null) {
  selectedValue.value = (value === '' ? null : value) as Value | null;
}
</script>

<template>
  <div>
    <component
      :is="component"
      :id="model.id"
      :label="model.label"
      :options="model.options"
      :disabled="model.disabled"
      :placeholder="model.placeholder"
      :value="selectedValue"
      @change="onChange"
    />
    <FormFieldMessages :help-text="model.hint" :errors="model.errorMessages" />
  </div>
</template>
